import { useEffect } from "react";
import { useSelector } from "react-redux";
import { Check } from "lucide-react";
import ArrowSorting from "../../common/ArrowSorting";
import AllAcceptReject from "./AllAcceptReject";

export default function TableHead({
  headList,
  isMultipleCheck,
  isAllCheck,
  setAllCheck,
  setCheckedRow,
  checkedRow,
  setCheckedData,
  checkedType,
  setCheckedType,
}) {
  const data = useSelector((state) => state.data.data);
  const dataIds = data.map((item) => item.id);

  const handleAllChecks = () => {
    setAllCheck((prev) => {
      if (!prev && (checkedType.accept || checkedType.reject)) {
        const getIdsStatus = checkedType.accept ? true : false;
        const updatedCheckedData = dataIds.map((id) => ({
          id: id,
          status: getIdsStatus,
        }));
        setCheckedData(updatedCheckedData);
        setCheckedRow(dataIds);
      } else {
        setCheckedData([]);
        setCheckedType({
          accept: false,
          reject: false,
        });
        setCheckedRow([]);
      }
      return !prev;
    });
  };

  useEffect(() => {
    if (isAllCheck) {
      setCheckedRow(dataIds);
    }
  }, [isAllCheck, setCheckedRow, data]);

  return (
    <tr className="table-head-row">
      {isMultipleCheck && (
        <th className="py-2 px-1">
          <button
            className={`allCheckBox ${isAllCheck ? "bg-dark-blue" : ""}`}
            onClick={handleAllChecks}
          >
            <Check
              size={15}
              strokeWidth={4}
              className={`${isAllCheck ? "" : "opacity-0"} mr-2`}
            />
          </button>
        </th>
      )}
      {headList.map((item, ind) => {
        if (
          checkedRow &&
          checkedRow.length > 0 &&
          item.title === "Accept/Reject"
        ) {
          return (
            <AllAcceptReject
              key={ind}
              checkedRow={checkedRow}
              setCheckedData={setCheckedData}
              ind={ind}
              setCheckedType={setCheckedType}
              checkedType={checkedType}
            />
          );
        }
        return (
          <th className="table-head-th" key={ind}>
            <span className="flex justify-center items-center">
              {item.title}
              {item.sortArrow && data.length > 1 && (
                <ArrowSorting sortBy={item.sortBy} address={item.address} />
              )}
            </span>
          </th>
        );
      })}
    </tr>
  );
}
